import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersModule } from '../filters/filters.module';
import { SharedModule } from '../shared/shared.module';
import { ChatModalComponent } from './components/chat-modal/chat-modal.component';
import { ChatToggleComponent } from './components/chat-toggle/chat-toggle.component';
import { ConversationComponent } from './components/conversation/conversation.component';
import { ConversationsListItemComponent } from './components/conversations-list-item/conversations-list-item.component';
import { SearchUserComponent } from './components/search-user/search-user.component';

const declarations = [
    ChatToggleComponent,
    ChatModalComponent,
    ConversationsListItemComponent,
    ConversationComponent,
    SearchUserComponent
];

@NgModule({
    declarations: declarations,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, FiltersModule, TranslateModule, HttpClientModule],
    exports: declarations,
})
export class ChatModule {}
